import React, { createContext, useState, useEffect, useMemo } from 'react';
import { getCookie, setCookie } from '../utils/cookieUtils';

export const ThemeContext = createContext({
    mode: 'light',
    toggleTheme: () => { },
});

export const ThemeProvider = ({ children }) => {
    // Check cookie for theme preference, default to 'light'
    const [mode, setMode] = useState(() => {
        const savedMode = getCookie('theme_mode');
        if (savedMode) return savedMode;
        
        // Fallback to system preference
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark';
        }
        return 'light';
    });

    const toggleTheme = () => {
        const newMode = mode === 'light' ? 'dark' : 'light';
        setMode(newMode);
        setCookie('theme_mode', newMode);
    };

    // Apply dark/light class on mount and mode change
    useEffect(() => {
        if (mode === 'dark') {
            document.documentElement.classList.add('dark');
            document.documentElement.classList.remove('light');
        } else {
            document.documentElement.classList.remove('dark');
            document.documentElement.classList.add('light');
        }
    }, [mode]);

    const contextValue = useMemo(() => ({
        mode,
        toggleTheme
    }), [mode]);

    return (
        <ThemeContext.Provider value={contextValue}>
            {children}
        </ThemeContext.Provider>
    );
};

export default ThemeContext;
